import { Button } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const BotsList = ({}) => {
  const { t } = useTranslation();

  const [selectedChat, setSelectedChat] = useState();

  const array = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

  const handleSelectChatbot = (chat) => {
    setSelectedChat(chat);
  };
  return (
    <>
      <div className="bots-list-container">
        {array?.length > 0 ? (
          <>
            {array?.map((chat, index) => {
              return (
                <div
                  key={index}
                  className="chats-list"
                  onClick={() => handleSelectChatbot(chat)}
                  style={{
                    backgroundColor: selectedChat === chat ? "#0b4eb8" : "#fff",
                    color: selectedChat === chat ? "#fff" : "#000",
                    transition: "background-color 0.3 ease-out",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      icon={"V"} // Replace with your logic for initials
                      type="text"
                      size="small"
                      disabled={false}
                      style={{
                        backgroundColor:
                          selectedChat === chat ? "#fff" : "#0b4eb8",
                        color: selectedChat === chat ? "#000" : "#fff",
                        borderRadius: "50%",
                        minWidth: "30px",
                      }}
                    />

                    <div
                      style={{
                        marginLeft: "5px",
                      }}
                    >
                      {/* {chatbot?.name?.length > 30
                        ? chatbot?.name?.slice(0, 30) + "..."
                        : chatbot?.name} */}
                      Copilotly Chat
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          <h3
            style={{
              height: "calc(100vh - 220px)",
              marginTop: "1.5rem",
              textAlign: "center",
              color: "#000",
              fontSize: "1.2rem",
              fontWeight: "500",
            }}
          >
            {t("chatMessages.chatList.noBotFound")} <br />
            {t("chatMessages.chatList.itsGhostTown")}
          </h3>
        )}
      </div>
    </>
  );
};

export default BotsList;
